/** @jsx h */
import { Element } from 'slate';
import h from '../../hyperscript';
import * as Paragraph from './paragraph';

export function create(): Element {
  return <header>{Paragraph.create()}</header>;
}
